import React, { useState, useEffect, useRef } from "react";
import { REQUEST_URL, ALERT_TIMEOUT } from "../Config";
import LoadingBar from "react-top-loading-bar";

function HistoryContent() {
  //type
  const HISTORY_TYPE = {
    HUMANIZE_TEXT: "HUMANIZE_TEXT",
    AI_DETECTOR: "AI_DETECTOR",
    PARAPHRASE_TEXTS: "PARAPHRASE_TEXTS",
    SUMMARIZE_TEXT: "SUMMARIZE_TEXT",
    PLAGIARISM_DETECTOR: "PLAGIARISM_DETECTOR",
  };

  //current state
  const [searchType, setSearchType] = useState(HISTORY_TYPE.HUMANIZE_TEXT);
  //search history state
  const [searchedHistory, setSearchedHistory] = useState([]);
  //loading progress
  const [progress, setProgress] = useState(0);
  //check
  var hasCalledAPI = useRef(false);

  //alert state
  const [alert, setAlert] = useState({
    type: "success",
    message: "",
    visible: false,
  });

  // Function to simulate progress updates
  const startLoading = () => {
    setProgress(30); // Start with some progress
    // Simulate an async operation
    setTimeout(() => {
      setProgress(70);
    }, 500);
  };

  //use effect to handle api call
  useEffect(() => {
    //check
    if (hasCalledAPI.current === false) {
      //set
      hasCalledAPI.current = true;
      //call api to get search history
      searchHistoryAPI();
      //start loading
      startLoading();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  //api call search history
  const deleteSearchHistoryAPI = async (id) => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "DELETE_SEARCH_HISTORY",
        id_search: id,
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //set alert state to show error
        setAlert({
          type: data.success ? "success" : "danger",
          message: data.message,
          visible: true,
        });
        //hide alert after 5 seconds
        setTimeout(() => {
          setAlert({ ...alert, visible: false });
        }, ALERT_TIMEOUT);

        //remove item from array
        if (data.success === true) {
          //updated item list
          const updatedList = searchedHistory.filter((item) => item.id !== id);
          //update
          setSearchedHistory(updatedList);
        }

        console.log("Response Data:", data);
      })
      .catch((error) => {
        console.error("Error:", error);
      });

    console.log("Delete search history of id: ", id);
  };

  //api call search history
  const searchHistoryAPI = async () => {
    //get the access token from local storage
    var accessToken = localStorage.getItem("access_token");
    accessToken =
      accessToken !== null && accessToken !== "undefined" ? accessToken : "";

    //fetch the status from the API
    await fetch(REQUEST_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`, // if needed
      },
      body: JSON.stringify({
        request_type: "GET_SEARCH_HISTORY",
      }),
    })
      .then((response) => response.json())
      .then((data) => {
        //if success
        if (data.success === true) {
          //set array
          setSearchedHistory(data.response);
        }

        // Simulate an async operation
        setTimeout(() => {
          //set progress
          setProgress(100);
        }, 500);

        console.log("Response Data:", data);
      })
      .catch((error) => {
        // Simulate an async operation
        setTimeout(() => {
          //set progress
          setProgress(100);
        }, 500);
        console.error("Error:", error);
      });

    console.log("Load search history");
  };

  //return
  return (
    <div>
      <LoadingBar
        progress={progress}
        onLoaderFinished={() => setProgress(0)} // Reset on completion
      />
      <div className="p-3">
        <div className="container">
          <div style={{ marginTop: "6rem" }}>
            {/* Alert for failure */}
            <div
              className={`alert alert-${alert.type} ${
                alert.visible ? "" : "d-none"
              } fade show`}
              role="alert"
              style={{ marginTop: "5rem" }}
            >
              {alert.message}
            </div>

            {/* Heading */}
            <h1 className="display-6 text-center mt-2">Search History</h1>

            {/*Tabs AI Detector & Humanizer*/}
            <ul className="nav nav-tabs">
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    searchType === HISTORY_TYPE.HUMANIZE_TEXT ? "active" : ""
                  }`}
                  aria-current="page"
                  onClick={() => {
                    //set
                    setSearchType(HISTORY_TYPE.HUMANIZE_TEXT);
                  }}
                >
                  Humanized Texts
                </button>
              </li>
              <li className="nav-item">
                <button
                  className={`nav-link ${
                    searchType === HISTORY_TYPE.AI_DETECTOR ? "active" : ""
                  }`}
                  aria-current="page"
                  onClick={() => {
                    //set
                    setSearchType(HISTORY_TYPE.AI_DETECTOR);
                  }}
                >
                  AI Detector
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link ${
                    searchType === HISTORY_TYPE.PARAPHRASE_TEXTS ? "active" : ""
                  }`}
                  aria-current="page"
                  onClick={() => {
                    //set
                    setSearchType(HISTORY_TYPE.PARAPHRASE_TEXTS);
                  }}
                >
                  PARAPHRASED TEXTS
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link ${
                    searchType === HISTORY_TYPE.SUMMARIZE_TEXTS ? "active" : ""
                  }`}
                  aria-current="page"
                  onClick={() => {
                    //set
                    setSearchType(HISTORY_TYPE.SUMMARIZE_TEXTS);
                  }}
                >
                  SUMMARIZED TEXT
                </button>
              </li>

              <li className="nav-item">
                <button
                  className={`nav-link ${
                    searchType === HISTORY_TYPE.PLAGIARISM_DETECTOR
                      ? "active"
                      : ""
                  }`}
                  aria-current="page"
                  onClick={() => {
                    //set
                    setSearchType(HISTORY_TYPE.PLAGIARISM_DETECTOR);
                  }}
                >
                  PLAGIARISM CHECKER
                </button>
              </li>
            </ul>

            {/* Content List */}
            <div className="mt-5">
              <ul>
                {searchedHistory.filter((item) =>
                  searchType === HISTORY_TYPE.AI_DETECTOR
                    ? item.search_type === "AI_DETECTOR"
                    : searchType === HISTORY_TYPE.HUMANIZE_TEXT
                    ? item.search_type === "HUMANIZE_TEXT"
                    : searchType === HISTORY_TYPE.PARAPHRASE_TEXTS
                    ? item.search_type === "PARAPHRASE_TEXTS"
                    : searchType === "SUMMARIZE_TEXT"
                    ? item.search_type === "SUMMARIZE_TEXT"
                    : item.search_type === "PLAGIARISM_DETECTOR"
                ).length > 0 ? (
                  searchedHistory
                    .filter((item) =>
                      searchType === HISTORY_TYPE.AI_DETECTOR
                        ? item.search_type === "AI_DETECTOR"
                        : searchType === HISTORY_TYPE.HUMANIZE_TEXT
                        ? item.search_type === "HUMANIZE_TEXT"
                        : searchType === HISTORY_TYPE.PARAPHRASE_TEXTS
                        ? item.search_type === "PARAPHRASE_TEXTS"
                        : searchType === "SUMMARIZE_TEXT"
                        ? item.search_type === "SUMMARIZE_TEXT"
                        : item.search_type === "PLAGIARISM_DETECTOR"
                    )
                    .map((item, index) => {
                      return (
                        <li key={index}>
                          <div className="mt-5 d-flex">
                            <b className="lead">{item.created_at}</b>
                            <button
                              type="button"
                              className="btn btn-outline-danger ms-auto"
                              onClick={(e) => {
                                //blur
                                e.currentTarget.blur();
                                //delete
                                deleteSearchHistoryAPI(item.id);
                              }}
                            >
                              <i className="bi bi-trash"></i>
                            </button>
                          </div>
                          <div>
                            <div
                              className="accordion"
                              id="accordion_search_history"
                            >
                              <div className="accordion-item mt-3 bg-light">
                                <label
                                  className="accordion-header lead w-100"
                                  id={`heading${index}`}
                                >
                                  <button
                                    className="accordion-button"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target={`#collapse${index}`}
                                    aria-expanded="true"
                                    aria-controls={`collapse${index}`}
                                  >
                                    {item.text_searched}
                                  </button>
                                </label>

                                <div
                                  id={`collapse${index}`}
                                  className="accordion-collapse collapse show"
                                  aria-labelledby={`heading${index}`}
                                  data-bs-parent="#accordion_search_history"
                                >
                                  <div className="accordion-body text-muted">
                                    {item.search_type === "AI_DETECTOR" ||
                                    item.search_type === "PLAGIARISM_DETECTOR"
                                      ? item.text_result +
                                        `% ${
                                          item.search_type === "AI_DETECTOR"
                                            ? "AI"
                                            : "Original content"
                                        }`
                                      : item.text_result}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </li>
                      );
                    })
                ) : (
                  <label className="container text-center text-muted mt-5">
                    {" "}
                    No history found. Start using app to convert AI written
                    texts to human like, summarize texts, paraphrase texts, ai
                    detetion etc.
                  </label>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default HistoryContent;
